module.exports = __webpack_public_path__ + "static/media/huanjing1.f32bebb5.png";